import { useTheme } from '@mui/material'

export default function useWidgetColors() {
    const theme = useTheme()
    return theme.custom.widgetColors || Object.keys(theme.palette.tada).map(colorName => theme.palette.tada[colorName])
}
